<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in keyword here"
                  append-icon="search"
                  label="Search Announcement"
                  clearable
                />
              </v-col>
              <v-col
                cols="4"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="announcementCategoryFilter"
                  clearable
                  :items="announcementCategories"
                  label="Announcement Category Filter"
                  placeholder="Choose announcement category"
                  item-text="name"
                  item-value="id"
                  value="id"
                />
              </v-col>
              <v-spacer />
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-newsletter-announcements-dialog-create @created="loadData" />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :items="filterAnnouncement"
            :loading="loading"
            :search="search"
          >
            <template v-slot:item.title="{ item }">
              <div>
                <span>{{ item.title }}</span>
              </div>
            </template>

            <template v-slot:item.announcement_date="{ item }">
              <div>
                <span>{{ $moment(item.announcement_date, 'YYYY-MM-DD').format('DD MMM YYYY') }}</span>
              </div>
            </template>

            <template v-slot:item.announcement_category_id="{ item }">
              <div>
                <v-icon>
                  {{ item.announcement_category_id }}
                </v-icon>
              </div>
            </template>

            <template v-slot:item.is_public="{ item }">
              <div>
                <span>{{ item.is_public ? 'Public' : 'Private' }}</span>
              </div>
            </template>

            <template v-slot:item.is_published="{ item }">
              <div>
                <setup-newsletter-announcements-dialog-publish
                  :announcement="item"
                  @published="loadData"
                />
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <div>
                <setup-newsletter-announcements-dialog-edit
                  :announcement="item"
                  @updated="loadData"
                />
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupNewsletterAnnouncementsDialogCreate: () => import('@/components/setup/newsletter/announcements/DialogCreate'),
      SetupNewsletterAnnouncementsDialogPublish: () => import('@/components/setup/newsletter/announcements/DialogPublish'),
      SetupNewsletterAnnouncementsDialogEdit: () => import('@/components/setup/newsletter/announcements/DialogEdit'),
    },
 
    data () {
      return {
        announcements: [],
        announcementCategories: [],
        announcementCategoryFilter: '',
        headers: [
          {
            text: 'Title',
            align: 'left',
            value: 'title',
          },
          {
            text: 'Date',
            align: 'left',
            value: 'announcement_date',
          },
          {
            text: 'Category',
            align: 'center',
            value: 'announcement_category.name',
          },
          {
            text: 'Public / Private?',
            align: 'center',
            value: 'is_public',
          },
          {
            text: 'Published?',
            align: 'center',
            value: 'is_published',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        loading: false,
      }
    },
    computed: {
      filterAnnouncement () {
        return this.announcements.filter(annoucement => {
          if (!this.announcementCategoryFilter) return annoucement
          return annoucement.announcement_category_id === this.announcementCategoryFilter
        })
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true

        this.loadAnnouncementCategories()
        this.$api.announcements().list()
          .then(response => {
            this.announcements = _.orderBy(response.data, ['created_at'], ['desc'])  
            this.loading = false
          })
      },
      loadAnnouncementCategories () {
        this.$api.announcementCategories().list()
          .then(response => {
            this.announcementCategories = response.data
          })
      },
    },
  }
</script>
